export const ROUTES = {
    ROOT: '/',
    WELCOME: '/welcome',
    DASHBOARD: '/dashboard',
    VIEW_VEHICLE: '/listing',
    VEHICLE_SUMMARY: '/vehicle-summary',
    LOGIN: '/login',
    HOME: '/home',
    REGISTER: '/register',
    REDIRECT: '/redirect',
    LOGOUT: '/logout',
    FORGOT_PASSWORD: '/forgot-password',
    FORGOT_USERNAME: '/forgot-username',
    SEARCH_VEHICLE_LIST: '/vehicles',
    GET_IN_TOUCH:'/get-in-touch',
    USERS: '/users',
    TESTS: '/tests',
    TERMS: '/terms',
    ABOUT_US: '/about-us',
    RENTAL_VEHICLE_AGENCIES:'/rental-vehicle-agencies',
    PRIVACY_POLICY: '/privacy-policy',
    COOKIES_POLICY: '/cookies-policy',
    CANCELLATION_POLICY:'/cancellation-policy',
    DRIVER_TRIPS: '/trip',
    EVENTS: '/events',
    REQUESTS: '/requests',
    DRIVER_RATINGS: '/ratings',
    EMERGENCY_ACCESS: '/emergency-access',
    USER_DETAIL: '/users-details',
    DRIVER_PROFILE: '/driver-profile',
    EVENTS_DETAILS: '/events-details',
    SUCCESSFUL_BOOKING: '/vehicle-booked',
    FAQ: '/faq',
    EDIT_TEST_QUESTION: '/test-question',
    MANAGE_ROLES: '/user-types',
    GOOGLE_SIGNIN: "/google-signin",
    RESEND_LINK: '/resend-link',
    ADD_NEW_LIST: "/add-new-list",
    DRIVER_RATING: "/driver-rating",
    VEHICLE: "/vehicle",
    TOKEN: "/token",
    EDIT_LISTING: "/edit-list",
    INSURANCE: "/insurances",
    PAGEVIEWS: "/pageviews",
    HOW_IT_WORK: "/how-it-works",
    GET_INSURANCE: "/insurance",
    BRANCH: "/branch",
    VIEW_LISTING: "/list-view",
    INVITE_DRIVER: "/invite-driver",
    EMAIL_OPTIONS: "/email-options",
    CONTACT: "/contact",
    BILLING: "/billing",
    STATEMENT: "/statement",
    PAYMENT: "/payment",
    COMPANY_DETAILS: '/company-details',
    COPY_LISTING: "/copy-listing",
    EDIT_BRANCH: "/edit-branch",
    EDIT_VEHICLE: "/edit-vehicle",
    AGENCY_PROFILE: "/profile",
    DASHBOARD_LIST: "/dashboard-list",
    RATINGS: "/agency-rating",
    DRIVER_PAYMENT: "/payment"
}